import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { f, database, storage, auth } from "../config";
import firebase from "firebase";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import Swal from 'sweetalert2'
import emailjs from "emailjs-com";

function Dashboard() {
    return (
        <div>

            {/* Site wrapper */}
            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    {/* Left navbar links */}
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars" /></a>
                        </li>
                    </ul>
                </nav>
                {/* /.navbar */}
                {/* Main Sidebar Container */}
                <aside className="main-sidebar sidebar-dark-primary elevation-4">
                    {/* Brand Logo */}
                    <a href="https://chainblockinvestment.com" className="brand-link">
                        <img src="https://img.icons8.com/?size=80&id=68733&format=png" className="brand-image img-circle elevation-2" style={{ opacity: '.8' }} width={30} />
                        <span className="brand-text font-weight-light">Investment Admin</span>
                    </a>
                    {/* Sidebar */}
                    <div className="sidebar">
                        {/* Sidebar user (optional) */}
                        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                            <div className="image">
                                <img src="https://img.icons8.com/?size=80&id=68733&format=png" className="img-circle elevation-2" alt="User Image" />
                            </div>
                            <div className="info">
                                <a href="#" className="d-block">Darkest Mind</a>
                            </div>
                        </div>
                        {/* Sidebar Menu */}
                        <nav className="mt-2">
                            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                                {/* Add icons to the links using the .nav-icon class
           with font-awesome or any other icon font library */}
                                <li className="nav-item">
                                    <a href="/" className="nav-link">
                                        <i className="nav-icon fas fa-tachometer-alt" />
                                        <p>
                                            Dashboard
                                        </p>
                                    </a>
                                </li>
                              

                                <li className="nav-item">
                                    <a href="/users" className="nav-link">
                                        <i className="nav-icon fas fa-users" />
                                        <p>
                                            Manage Users
                                        </p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="/deposits" className="nav-link">
                                        <i className="nav-icon fas fa-donate" />
                                        <p>
                                            Manage Deposits
                                        </p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="/withdrawals" className="nav-link">
                                        <i className="nav-icon fas fa-hand-holding-usd" />
                                        <p>
                                            Manage Withdrawals
                                        </p>
                                    </a>
                                </li>

                                   <li className="nav-item">
                                    <a href="/investments" className="nav-link">
                                        <i className="nav-icon fas fa-hand-holding-usd" />
                                        <p>
                                        Manage Investments
                                        </p>
                                    </a>
                                </li>
 

                                <li className="nav-item">
                                    <a href="https://privateemail.com/" className="nav-link">
                                        <i className="nav-icon fas fa-envelope" />
                                        <p>
                                            webmail
                                        </p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="/logout" className="nav-link">
                                        <i className="nav-icon fas fa-power-off" />
                                        <p>
                                            Logout
                                        </p>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        {/* /.sidebar-menu */}
                    </div>
                    {/* /.sidebar */}
                </aside>
                {/* Content Wrapper. Contains page content */}
                <div className="content-wrapper" style={{ minHeight: '777px' }}>
                    {/* Content Header (Page header) */}
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1>Admin Dashboard</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="https://chainblockinvestment.com/admin">Home</a></li>
                                        <li className="breadcrumb-item active">Admin Dashboard</li>
                                    </ol>
                                </div>
                            </div>
                        </div>{/* /.container-fluid */}
                    </section>
                    {/* Main content */}
                    <section className="content">
                        {/* Default box */}
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <div className="info-box">
                                            <span className="info-box-icon bg-dark elevation-1"><i className="fas fa-users" /></span>
                                            <div className="info-box-content">
                                                <span className="info-box-text">Users</span>
                                                <span className="info-box-number" id="users_count">running</span>
                                            </div>
                                            {/* /.info-box-content */}
                                        </div>
                                        {/* /.info-box */}
                                    </div>
                                    {/* /.col */}
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <div className="info-box mb-3">
                                            <span className="info-box-icon bg-dark elevation-1"><i className="fab fa-pagelines" /></span>
                                            <div className="info-box-content">
                                                <span className="info-box-text">Minings</span>
                                                <span className="info-box-number" id="mining_count">0</span>
                                            </div>
                                            {/* /.info-box-content */}
                                        </div>
                                        {/* /.info-box */}
                                    </div>
                                    {/* /.col */}
                                    {/* fix for small devices only */}
                                    <div className="clearfix hidden-md-up" />
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <div className="info-box mb-3">
                                            <span className="info-box-icon bg-dark elevation-1"><i className="fas fa-chart-line" /></span>
                                            <div className="info-box-content">
                                                <span className="info-box-text">Investments</span>
                                                <span className="info-box-number" id="investment_count">running</span>
                                            </div>
                                            {/* /.info-box-content */}
                                        </div>
                                        {/* /.info-box */}
                                    </div>
                                    {/* /.col */}
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <div className="info-box mb-3">
                                            <span className="info-box-icon bg-dark elevation-1"><i className="fas fa-dollar-sign" /></span>
                                            <div className="info-box-content">
                                                <span className="info-box-text">Total Deposits</span>
                                                <span className="info-box-number" id="total_deposit_usd">running</span>
                                            </div>
                                            {/* /.info-box-content */}
                                        </div>
                                        {/* /.info-box */}
                                    </div>
                                    {/* /.col */}
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-md-12">
                                        <coingecko-coin-price-marquee-widget currency="usd" coin-ids="bitcoin,bitcoin-cash-sv,ethereum,eos,ripple,litecoin" locale="en" vce-ready />
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* TradingView Widget BEGIN */}
                                        <div className="tradingview-widget-container" style={{ width: '100%', height: '660px' }}>
                                            <iframe scrolling="no" allowTransparency="true" frameBorder={0} src="https://s.tradingview.com/embed-widget/market-overview/?locale=en#%7B%22colorTheme%22%3A%22dark%22%2C%22dateRange%22%3A%2212M%22%2C%22showChart%22%3Atrue%2C%22largeChartUrl%22%3A%22%22%2C%22isTransparent%22%3Afalse%2C%22showSymbolLogo%22%3Atrue%2C%22width%22%3A%22100%25%22%2C%22height%22%3A%22660%22%2C%22plotLineColorGrowing%22%3A%22rgba(25%2C%20118%2C%20210%2C%201)%22%2C%22plotLineColorFalling%22%3A%22rgba(25%2C%20118%2C%20210%2C%201)%22%2C%22gridLineColor%22%3A%22rgba(42%2C%2046%2C%2057%2C%201)%22%2C%22scaleFontColor%22%3A%22rgba(120%2C%20123%2C%20134%2C%201)%22%2C%22belowLineFillColorGrowing%22%3A%22rgba(33%2C%20150%2C%20243%2C%200.12)%22%2C%22belowLineFillColorFalling%22%3A%22rgba(33%2C%20150%2C%20243%2C%200.12)%22%2C%22symbolActiveColor%22%3A%22rgba(33%2C%20150%2C%20243%2C%200.12)%22%2C%22tabs%22%3A%5B%7B%22title%22%3A%22Indices%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22FOREXCOM%3ASPXUSD%22%2C%22d%22%3A%22S%26P%20500%22%7D%2C%7B%22s%22%3A%22FOREXCOM%3ANSXUSD%22%2C%22d%22%3A%22Nasdaq%20100%22%7D%2C%7B%22s%22%3A%22FOREXCOM%3ADJI%22%2C%22d%22%3A%22Dow%2030%22%7D%2C%7B%22s%22%3A%22INDEX%3ANKY%22%2C%22d%22%3A%22Nikkei%20225%22%7D%2C%7B%22s%22%3A%22INDEX%3ADEU30%22%2C%22d%22%3A%22DAX%20Index%22%7D%2C%7B%22s%22%3A%22FOREXCOM%3AUKXGBP%22%2C%22d%22%3A%22FTSE%20100%22%7D%5D%2C%22originalTitle%22%3A%22Indices%22%7D%2C%7B%22title%22%3A%22Commodities%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22CME_MINI%3AES1!%22%2C%22d%22%3A%22S%26P%20500%22%7D%2C%7B%22s%22%3A%22CME%3A6E1!%22%2C%22d%22%3A%22Euro%22%7D%2C%7B%22s%22%3A%22COMEX%3AGC1!%22%2C%22d%22%3A%22Gold%22%7D%2C%7B%22s%22%3A%22NYMEX%3ACL1!%22%2C%22d%22%3A%22Crude%20Oil%22%7D%2C%7B%22s%22%3A%22NYMEX%3ANG1!%22%2C%22d%22%3A%22Natural%20Gas%22%7D%2C%7B%22s%22%3A%22CBOT%3AZC1!%22%2C%22d%22%3A%22Corn%22%7D%5D%2C%22originalTitle%22%3A%22Commodities%22%7D%2C%7B%22title%22%3A%22Bonds%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22CME%3AGE1!%22%2C%22d%22%3A%22Eurodollar%22%7D%2C%7B%22s%22%3A%22CBOT%3AZB1!%22%2C%22d%22%3A%22T-Bond%22%7D%2C%7B%22s%22%3A%22CBOT%3AUB1!%22%2C%22d%22%3A%22Ultra%20T-Bond%22%7D%2C%7B%22s%22%3A%22EUREX%3AFGBL1!%22%2C%22d%22%3A%22Euro%20Bund%22%7D%2C%7B%22s%22%3A%22EUREX%3AFBTP1!%22%2C%22d%22%3A%22Euro%20BTP%22%7D%2C%7B%22s%22%3A%22EUREX%3AFGBM1!%22%2C%22d%22%3A%22Euro%20BOBL%22%7D%5D%2C%22originalTitle%22%3A%22Bonds%22%7D%2C%7B%22title%22%3A%22Forex%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22FX%3AEURUSD%22%7D%2C%7B%22s%22%3A%22FX%3AGBPUSD%22%7D%2C%7B%22s%22%3A%22FX%3AUSDJPY%22%7D%2C%7B%22s%22%3A%22FX%3AUSDCHF%22%7D%2C%7B%22s%22%3A%22FX%3AAUDUSD%22%7D%2C%7B%22s%22%3A%22FX%3AUSDCAD%22%7D%5D%2C%22originalTitle%22%3A%22Forex%22%7D%2C%7B%22title%22%3A%22Crypto%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22BITBAY%3ABTCUSD%22%7D%2C%7B%22s%22%3A%22KRAKEN%3AETHUSD%22%7D%2C%7B%22s%22%3A%22BITFINEX%3ABSVUSD%22%7D%2C%7B%22s%22%3A%22BITFINEX%3ATRXUSD%22%7D%5D%7D%5D%2C%22utm_source%22%3A%22chainblockinvestment.com%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22market-overview%22%7D" style={{ boxSizing: 'border-box', height: 'calc(628px)', width: '100%' }} />
                                            <div className="tradingview-widget-copyright"><a href="https://www.tradingview.com" rel="noopener" target="_blank"><span className="blue-text">Crypto</span></a> by TradingView</div>
                                            <style dangerouslySetInnerHTML={{ __html: "\n\t.tradingview-widget-copyright {\n\t\tfont-size: 13px !important;\n\t\tline-height: 32px !important;\n\t\ttext-align: center !important;\n\t\tvertical-align: middle !important;\n\t\t/* @mixin sf-pro-display-font; */\n\t\tfont-family: -apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif !important;\n\t\tcolor: #9db2bd !important;\n\t}\n\n\t.tradingview-widget-copyright .blue-text {\n\t\tcolor: #2962FF !important;\n\t}\n\n\t.tradingview-widget-copyright a {\n\t\ttext-decoration: none !important;\n\t\tcolor: #9db2bd !important;\n\t}\n\n\t.tradingview-widget-copyright a:visited {\n\t\tcolor: #9db2bd !important;\n\t}\n\n\t.tradingview-widget-copyright a:hover .blue-text {\n\t\tcolor: #1E53E5 !important;\n\t}\n\n\t.tradingview-widget-copyright a:active .blue-text {\n\t\tcolor: #1848CC !important;\n\t}\n\n\t.tradingview-widget-copyright a:visited .blue-text {\n\t\tcolor: #2962FF !important;\n\t}\n\t" }} /></div>
                                        {/* TradingView Widget END */}
                                    </div>
                                </div>
                            </div>
                            {/* /.card-body */}
                        </div>
                        {/* /.card */}
                    </section>
                    {/* /.content */}
                </div>
                {/* /.content-wrapper */}
                <footer className="main-footer">
                    <div className="float-right d-none d-sm-block">
                        <b>Version</b> 3.0.4
                    </div>
                    <strong>Copyright © 2022 <a href="https://chainblockinvestment.com">Investment Admin</a>.</strong> All rights
                    reserved.
                </footer>
                <div id="sidebar-overlay" /></div>
        </div>
    )
}

export default Dashboard